import { render } from "./ReserveRoom.vue?vue&type=template&id=6427e8c1&scoped=true"
import script from "./ReserveRoom.vue?vue&type=script&lang=js"
export * from "./ReserveRoom.vue?vue&type=script&lang=js"

import "./ReserveRoom.vue?vue&type=style&index=0&id=6427e8c1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6427e8c1"]])

export default __exports__